export { default } from './ProbabilityCell';
